<script>
  import kebabcase from "lodash.kebabcase";
  import { mapGetters, mapActions } from "vuex";
  import {
    convertBoolean,
    getRandomInt,
    IsValid,
    HashCodeFromInt,
    hexToRgb
  } from "@/modules/helper/index";
  import ImageBrowser from "./ImageBrowser.vue";

  export default {
    components: {
      appImageBrowser: ImageBrowser
    },
    data() {
      return {
        // SubscriptionModuleId: this.$route.params.Id,
        selectedCategory: "",
        GallerieInformation: []
      };
    },
    computed: {
      ...mapGetters([
        "ImageGalleries",
        "MainMenuLayout",
        "AppConfig",
        "SelectedAlbumtab",
        "ActiveAlbumCategory",
        "AlbumTabsInit",
        "Galleries",
        "DesignSettings"
      ]),
      SubscriptionModuleId() {
        return this.$f7route.params.Id;
      },
      PostCategories() {
        if (this.ImageGalleries.Parent.PostCategories) {
          let Category = JSON.parse(this.ImageGalleries.Parent.PostCategories);
          this.selectedCategory = this.SelectedAlbumtab
            ? this.selectedCategory || Category[0]
            : Category[0];
          return Category;
        } else {
          let data = [
            ...new Set(this.ImageGalleries.Galleries.map(post => post.Category))
          ]; // if category not present in parent then find into the post.
          this.selectedCategory = this.SelectedAlbumtab
            ? this.selectedCategory || data[0]
            : data[0];
          return data;
        }
      },
      headerElements() {
        let imageGalleries = this.ImageGalleries;
        let headerElements;
        if (imageGalleries.Parent.HeaderElements) {
          headerElements = JSON.parse(imageGalleries.Parent.HeaderElements);
        }
        return headerElements;
      },
      footerElements() {
        let imageGalleries = this.ImageGalleries;
        let footerElements;
        if (imageGalleries.Parent.FooterElements) {
          footerElements = JSON.parse(imageGalleries.Parent.FooterElements);
        }
        return footerElements;
      },
      oneAlbum() {
        if (
          this.ImageGalleries.Galleries.length === 1 &&
          this.ImageGalleries.Galleries[0].Albums.length === 1
        ) {
          return true;
        }
        return false;
      },
      oneAlbumDetails() {
        if (this.oneAlbum) {
          return this.ImageGalleries.Galleries[0].Albums[0];
        } else {
          return {};
        }
      },
      headerTitle() {
        if (this.oneAlbum) {
          return this.ImageGalleries.Galleries[0].Albums[0].AlbumName;
        } else {
          return this.ImageGalleries.Parent.PageTitle;
        }
      },
      UseCategories() {
        return !this.oneAlbum && true; // ImageGalleries.Parent.UseCategories
      },
      AllowLikes() {
        return convertBoolean(this.ImageGalleries.Parent.AllowLikes);
      },
      getNavStyle() {
        if (IsValid(this.DesignSettings.TitleBarOpacity)) {
          let hashCode = HashCodeFromInt(this.DesignSettings.AppThemeColor);
          let colorrgb = hexToRgb(hashCode);
          return {
            "z-index": "7000",
            color: HashCodeFromInt(this.DesignSettings.TitleBarFontColor),
            background:
              "rgba(" + colorrgb + "," + this.DesignSettings.TitleBarOpacity + ")"
          };
        }
      },
      randomNo() {
        return getRandomInt();
      }
    },
    watch: {
      ImageGalleries: function(ImageGalleries) {
        this.GallerieInformation = ImageGalleries.Galleries.filter(album => {
          return album.Albums.sort(function(a, b) {
            return a.OrderId - b.OrderId;
          });
        });
      },
      Galleries: function(Galleries) {
        this.GallerieInformation = Galleries.filter(album => {
          return album.Albums.sort(function(a, b) {
            return a.OrderId - b.OrderId;
          });
        });
      },
      SelectedAlbumtab: function(val, oldVal) {
        this.selectedCategory = val;
        if (!this.$f7) return;
        this.$f7.tab.show("#tab-" + this.categoryId(val), true);
      }
    },
    created() {
      this.initGallerieModule(this.SubscriptionModuleId);
    },
    mounted() {
      if (this.$refs.imageGalleryPage) {
        this.$refs.imageGalleryPage.$on("page:reinit", (event, payload) => {
          this.initGallerieModule(this.SubscriptionModuleId);
        });
      }
    },
    beforeDestroy() {
      if (this.$refs.imageGalleryPage) {
        this.setActiveAlbumCategory("");
        this.$refs.imageGalleryPage.$off("page:reinit", (event, payload) => {
          this.initGallerieModule(this.SubscriptionModuleId);
        });
      }
    },
    methods: {
      ...mapActions([
        "showLoader",
        "hideLoader",
        "loadModulesImageGalleriesLocalData",
        "loadImageGalleries",
        "setActiveAlbumCategory",
        "initAlbumTab"
      ]),
      initGallerieModule(SubscriptionModuleId) {
        this.showLoader();
        this.loadModulesImageGalleriesLocalData(SubscriptionModuleId);
        this.loadImageGalleries(SubscriptionModuleId)
          .then(() => {
            // if (!this.AlbumTabsInit) {
            //   this.$f7.initPageSwiper(this.$el)
            //   this.initAlbumTab(true)
            // }
            setTimeout(() => {
              if (this.oneAlbum) {
                this.hideLoader();
                // this.$f7.mainView.router.load({
                //   url: this.albumDetailUrl(this.ImageGalleries.Galleries[0].Albums[0].Id)
                // })
                this.$RegisterPageView({
                  SubscriptionModule_Id: SubscriptionModuleId,
                  ContentGUID: this.oneAlbumDetails.Id,
                  ViewType: 2
                });
              } else {
                this.$hideLoader();
                this.$RegisterPageView({
                  SubscriptionModule_Id: SubscriptionModuleId,
                  ContentGUID: this.ImageGalleries.Parent.Id,
                  ViewType: 1
                });
              }
            }, 1000);
          })
          .catch(err => {
            console.log("err", err);
            this.hideLoader();
            setTimeout(() => {
              if (this.oneAlbum) {
                // this.$f7.mainView.router.load({
                //   url: this.albumDetailUrl(this.ImageGalleries.Galleries[0].Albums[0].Id)
                // })
                this.$RegisterPageView({
                  SubscriptionModule_Id: SubscriptionModuleId,
                  ContentGUID: this.oneAlbumDetails.Id,
                  ViewType: 2
                });
              } else {
                this.$hideLoader();
                this.$RegisterPageView({
                  SubscriptionModule_Id: SubscriptionModuleId,
                  ContentGUID: this.ImageGalleries.Parent.Id,
                  ViewType: 1
                });
              }
              // if (!this.AlbumTabsInit) {
              //   this.$f7.initPageSwiper(this.$el)
              //   this.initAlbumTab(true)
              // }
            }, 1000);
          });
      },
      getStyle: function(ismaterial) {
        if (
          ismaterial &&
          this.UseCategories &&
          this.PostCategories.length > 1 &&
          this.PostCategories[0] !== ""
        ) {
          return {
            // marginTop: '56px',
            paddingTop: "104px"
          };
        } else if (
          !ismaterial &&
          this.UseCategories &&
          this.PostCategories.length > 1 &&
          this.PostCategories[0] !== ""
        ) {
          return {
            // marginTop: '45px',
            paddingTop: "90px"
          };
        }
      },
      albumDetailUrl: function(value) {
        return "/image-album-view/" + this.SubscriptionModuleId + "/" + value;
      },
      categoryId: function(value) {
        // return kebabcase(value) + "" + this.randomNo;
           var result = value.replace(/ /g, "-")
        return result + '' + this.randomNo

      },
      categorySelect(category, index) {
        if (this.ActiveAlbumCategory === category) {
          return true;
        } else if (this.ActiveAlbumCategory === "" && index === 0) {
          return true;
        }
        return false;
      },
      getAlbumByCategory(category) {
        let albums = this.GallerieInformation.find(
          album => album.Category === category
        );
        return albums ? albums.Albums : [];
      },
      getAlbumCoverImage(AlbumDetails) {
        return `${this.AppConfig.Urls.ContentAssetsBaseUrl}${
          AlbumDetails.Images.length > 0 ? AlbumDetails.Images[0].Image : ""
        }`;
      }
    }
  };
</script>
<template>
  <f7-page ref="imageGalleryPage" :page-content="false" v-if="ImageGalleries" :name="'image-gallery-view-'+ SubscriptionModuleId">
    <app-header :header="headerTitle" :isShowSubNavBar="UseCategories" :isShowRightNavBar="!oneAlbum" :randomNo="randomNo"></app-header>
    <!-- <app-tab-menu v-if="MainMenuLayout === 1 && !oneAlbum"></app-tab-menu> -->
    <div class="toolbar tabbar tabbar-scrollable" v-if="UseCategories && PostCategories.length > 1 && PostCategories[0] != '' && $theme.md">
        <div class="toolbar-inner">
          <f7-link v-for="(category,index) in PostCategories"
            :tab-link="'#tab-'+categoryId(category)"
            :key="index"
            :tab-link-active="categorySelect(category, index)">
            {{category}}
          </f7-link>
        </div>
    </div>
    <app-tab-menu v-if="MainMenuLayout === 1 && !oneAlbum"></app-tab-menu>
    <div class="backgroundimg"></div>
    <!-- Page content View -->
    <f7-page-content v-if="!oneAlbum && ImageGalleries.Galleries" :style="getStyle($theme.md)">
        <div v-if="headerElements" class="header-section">
          <component v-for="(el,index) in headerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
          </component>
        </div>
        <f7-tabs v-if="GallerieInformation.length > 0">
          <f7-tab v-for="(category,index) in PostCategories" :id="'tab-'+categoryId(category)" :key="index" :tab-active="categorySelect(category, index)">
            <f7-row class="album-wrapper">
                <f7-col v-for="(AlbumDetails, index1) in getAlbumByCategory(category)" width="50" tablet-width="33" :key="index1">
                  <f7-link class="album-link" :href="albumDetailUrl(AlbumDetails.Id)">
                    <div class="album-image-wrapper">
                      <div class="album-images" :style="'background-image:url('+getAlbumCoverImage(AlbumDetails)+')'">
                      </div>
                    </div>
                    <div class="album-name">{{AlbumDetails.AlbumName}}</div>
                    <div class="album-info">
                      <span>{{AlbumDetails.Images ? AlbumDetails.Images.length : 0}} &nbsp;Photos</span>
                      <span v-if="AllowLikes">{{AlbumDetails.Likes ? AlbumDetails.Likes : 0}}<span class="icon-dislike-them-color"></span>
                      </span>
                    </div>
                  </f7-link>
                </f7-col>
            </f7-row>
          </f7-tab>
        </f7-tabs>
        <div valign="bottom" v-if="footerElements" class="footer-section">
          <component v-for="(el, index) in footerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
          </component>
        </div>
      </f7-page-content>
      <app-image-browser v-if="oneAlbum && ImageGalleries.Galleries" :Parent="ImageGalleries.Parent" :SubscriptionModuleId="SubscriptionModuleId" :images="oneAlbumDetails.Images?oneAlbumDetails.Images:[]" :albumId="oneAlbumDetails.Id" :albumName="oneAlbumDetails.AlbumName"></app-image-browser>
  </f7-page>
</template>
<style scoped>
  .ios .page-with-subnavbar .page-content {
    padding-top: 44px
  }
  .album-wrapper > div .album-link {
    display: inline-block;
    padding: 20px 0;
    vertical-align: top;
    margin-top: 20px;
    position: relative;
    font-size: 14px;
    line-height: 18px;
  }

  .album-image-wrapper {
    position: relative;
    width: 105px;
    margin: 0 auto 20px;
  }

  .album-wrapper > div .album-link .album-images {
    border: 5px solid #fff;
    overflow: hidden;
    width: 105px;
    height: 105px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
  }

  .album-wrapper > div {
    text-align: center;
  }

  .album-link .album-image-wrapper:before,
  .album-link .album-image-wrapper:after {
    content: "";
    width: 115px;
    height: 115px;
    position: absolute;
    box-sizing: border-box;
    box-shadow: 0 1px 18px rgba(0, 0, 0, 0.4);
    transition: 0.3s all ease-out;
  }

  .album-link .album-image-wrapper:before {
    transform-origin: bottom left;
    transform: rotate(8deg);
    background-color: #8b8b8b;
    z-index: -10;
    left: -8px;
    top: -8px;
  }

  .album-link .album-image-wrapper:after {
    transform-origin: bottom left;
    transform: rotate(16deg);
    z-index: -20;
    background-color: #716f6f;
    left: -14px;
    top: -18px;
  }

  .album-info {
    font-size: 11px;
    /*color: #fff;*/
    display: flex;
    justify-content: space-around;
  }

  .album-info .icon-dislike-them-color {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-left: 5px;
  }

  .album-name {
    overflow: hidden;
    max-height: 38px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  @media only screen and (min-width: 768px) {
    .album-wrapper {
      justify-content: flex-start !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/image-gallery/ImageGallery.vue